export class Params {
    private utmSource: string;
    private sid: string;
    private campaignId: string;
    additionalParams: object;
    private publicIp: string;

    private gaid: string;
    private gasd: string;
    private gasdn: string;
    private fbp: string;

    constructor() {
        this.utmSource = "418761";
        this.sid = "unassigned";
        this.campaignId = "";
        this.additionalParams = {};
        this.publicIp = "";
        this.gaid = "n";
        this.gasd = "n";
        this.gasdn = "n";
        this.fbp = "";
    }

    // getters and setters
    getUtmSource() {
        return this.utmSource;
    }

    setUtmSource(utmSource: string) {
        this.utmSource = utmSource;
    }

    getSid() {
        return this.sid;
    }

    setSid(sid: string) {
        this.sid = sid;
    }

    getCampaignId() {
        return this.campaignId;
    }

    setCampaignId(campaignId: string) {
        this.campaignId = campaignId;
    }

    getAdditionalParams() {
        return this.additionalParams;
    }

    setAdditionalParams(additionalParams: object) {
        this.additionalParams = additionalParams;
    }

    getPublicIp() {
        return this.publicIp;
    }

    setPublicIp(publicIp: string) {
        this.publicIp = publicIp;
    }

    getGaid() {
        return this.gaid;
    }

    setGaid(gaid: string) {
        this.gaid = gaid;
    }

    getGasd() {
        return this.gasd;
    }

    setGasd(gasd: string) {
        this.gasd = gasd;
    }

    getGasdn() {
        return this.gasdn;
    }

    setGasdn(gasdn: string) {
        this.gasdn = gasdn;
    }

    getFbp() {
        return this.fbp;
    }

    setfbp(fbp: string) {
        this.fbp = fbp;
    }
}
